import React from "react"
import "./Collection.scss"

const Collection = () => {
    const Box = (props) => {
        return (
            <div className="bg-box col-span-1 font-poppins-bold uppercase text-white px-2 py-6 rounded-xl text-center">
                <h1 className="text-3xl md:text-4xl xl:text-5xl mb-4">
                    { props.title }
                </h1>
                <p>
                    { props.content }
                </p>    
            </div>
        )
    }

    const Detail = (props) => {
        return (
            <div className="flex items-center mb-4">
                <img src="/collection/icon_star.png" alt="star icon" className="w-8 mr-2"/>
                <p className="font-poppins-bold text-black text-lg uppercase">
                    { props.content }
                </p>
            </div>
        )
    }

    return (
        <div>
            <div className="border-b-8 border-blue bg-top flex justify-center items-center">
                <img src="/collection/dragons.png" alt="dragon image" className="w-2/3 sm:w-1/2"/>
            </div>
            <div className="xl:max-w-5xl mx-auto py-12 sm:py-16 px-4 sm:px-6">
                <div className="font-poppins">
                    <h1 className="font-poppins-bold text-blue text-2xl md:text-3xl xl:text-4xl uppercase mb-4">
                        Original Collection:
                    </h1>
                    <div className="md:text-lg">
                        <p>
                            The original WhelpS collection consisted of 7,777 lovingly hand-drawn dragon NFTs which evolved through 5 stages of evolution (Egg, Baby, Whelp, Young Adult Dragon, Adult Dragon).
                        </p>
                        <p className="my-6">
                            The first ever Ethereum time based evolution consisted of gaining traits of provable rarity with no user interaction at each stage!
                        </p>
                        <p>
                            The original collection sold out in a little over 24 hours and the project has further introduced concepts as staking for a new breed in addition to the transition to the Polygon network.
                        </p>
                    </div>
                </div>
                <div className="mt-16 grid grid-cols-1 sm:grid-cols-3 gap-4 md:gap-6 xl:gap-12">
                    <Box title="7,777" content="NFTs Sold Out in 25 hours" />
                    <Box title="$1.5M" content="Generated" />
                    <Box title="2000+" content="Unique holders" />
                </div>
                <div className="mt-10">
                    <Detail content='First ever "Evolving NFT" on Ethereum'/>
                    <Detail content='Successful Polygon Migration'/>
                    <Detail content='Staking system for new breed: highborn'/>
                </div>
            </div>
        </div>
    )
}

export default Collection;